import { type DataLayerItem } from '@leroy-merlin-br/backpack-analytics';

import { type Variants } from '@/infra/services/catalog/model';
import { getPromotionalPrice } from '@/presenters/components/catalog/PriceTag/utils';

import { DISCOUNT_TYPES } from './constants';
import {
  type DataLayerDiscountType,
  type DiscountType,
  type GetDataLayerItemProps,
} from './types';

export const getItemsJoinedByPipe = (items: (string | number)[]) => {
  return items.length > 0 ? items.join('|') : undefined;
};

export function getCurrentVariants(itemId: number, variants: Variants[]) {
  return variants.reduce<string[]>((acc, current) => {
    const currentVariant = current.types.find((type) => type.id === itemId);

    if (currentVariant) {
      acc.push(currentVariant.label);
    }

    return acc;
  }, []);
}

export function getDiscountType(
  discountType: DiscountType
): DataLayerDiscountType {
  return DISCOUNT_TYPES[discountType] || undefined;
}

export function getDiscount(toPrice: number, promotionalPrice: number) {
  if (!promotionalPrice || promotionalPrice === 0) {
    return 0;
  }

  return parseFloat((promotionalPrice - toPrice).toFixed(2));
}

export function getDataLayerItem({
  product,
  currentSeller,
  category,
  variants = [],
  quantity,
  boxQuantity,
}: GetDataLayerItemProps): DataLayerItem {
  const isBox = product.pack && product.pack.packaging !== 1;
  const isTwoPrices = currentSeller.pricing.discount.type === 'twoPrices';
  const promotionalPrice = getPromotionalPrice(currentSeller.pricing.price);
  const discount = getDiscount(
    currentSeller.pricing.price.to,
    promotionalPrice
  );

  return {
    id: product._id,
    name: product.name,
    type: 'product',
    price: currentSeller.pricing.price.to,
    discount: isTwoPrices ? undefined : discount,
    discountType: getDiscountType(currentSeller.pricing.discount.type),
    brand: product.brand,
    categoryTree: category.tree,
    variants: getCurrentVariants(product._id, variants),
    seller: currentSeller.shop.name || 'Leroy Merlin',
    quantity: quantity,
    box: isBox
      ? {
          unit: product.pack.packaging || undefined,
          price: product.pack.price || undefined,
          quantity: boxQuantity,
        }
      : undefined,
  };
}
